<template>
  <div id="user-file">
    <h2></h2>
    <div class="input-container">
      <FileUploader
      :placeholder="$t('users.manage.file.file_ph')"
      :type="'.csv'"
      :label="$t('users.manage.file.browse')"
      :fileUrl="fileUrl"
      @setFile="setFile"
      :clear="clear"
      />
      <div class="error-msg">
        <span v-if="$v.file.$error">{{$t("users.manage.file.errors.required")}}</span>
      </div>
    </div>
    <button
    :class="['upload-btn', { 'upload-btn--diabled': loadingFile }]"
    :disabled="loadingFile"
    @click="validateForm">{{$t("users.manage.file.upload")}}</button>
    <FileUploadAlert
    :name="alert.name"
    :status="alert.status" />
    <div class="error-msg-back">
      <!-- <p v-html="backendError"></p> -->
    </div>
          <b-modal style="z-index:20" size="lg" centered ref="my-info" hide-footer  scrollable title="Error" tabindex="-1" >
          <textarea v-model="backendError" class="form-control" rows="23">
          </textarea>
          </b-modal>
    
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import API_SERVICE from "@/lib/api/Users.js"
import S3_Handler from "@/lib/api/s3_handler";
const FileUploader = () => import("@/components/FileUploader");
const FileUploadAlert = () => import('@/components/alerts/FileUploadAlert.vue');
const api = new API_SERVICE();
const s3 = new S3_Handler();

export default {
  components: {
    FileUploader,
    FileUploadAlert
  },
  data: function() {
    return {
      clear:false,
      file: null,
      fileUrl: null,
      loadingFile: true,
      alert: {
        name: 'user',
        status: null
      },
      backendError: null
    };
  },
  validations: {
    file: {
      required
    }
  },
  mounted: async function() {
    try {
      let userType = this.$route.path.replace('/user/', '');
      switch(userType) {
        case 'manage':
          userType = 'collaborator'
        break;
        case 'volkswagenSP':
          userType = 'personal_vwsp'
        break;
        case 'utpStudents':
          userType = 'trainee_utp'
        break;
        case 'practitioners':
          userType = 'practicing'
        case 'chart':
          userType = 'chart'
        break;
      }
      const resp = await api.getUploadStatus('/users/sync', userType);
      if (!resp.data.status == true) {
        this.alert.status = 'loading';
        await api.statusInterval('/users/sync', userType);
        this.loadingFile = false;
        this.alert.status = 'success';
      } else {
        this.loadingFile = false;
        this.alert.status = null;
      }
    } catch (error) {
      throw error;
    }
  },
  beforeDestroy: function() {
    this.alert.status = null;
  },
  methods: {
    csvJSON(csvText) {
      const lines = csvText.split('\n'); // Split into individual lines
      const result = [];
      const headers = lines[0].split(','); // Extract headers from the first line

      for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentline = lines[i].split(','); // Split each line into values

        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j]; // Map header to value
        }
        result.push(obj);
      }
      return JSON.stringify(result); // Convert the array of objects to a JSON string
    },
    setFile: function(file) {
      this.file = file;
    },
    validateForm: async function() {
      this.clear = false;
      this.$v.$touch();
      if (this.$v.$error) return;

      
      await this.uploadFile();
      this.clear = true;
      /*let csv = [];
      const reader = new FileReader();
      reader.readAsText(this.file)
      reader.onload = async (readerEvent) => {
        csv = JSON.parse(this.csvJSON(readerEvent.target.result));

        let bandera = false;
        for (let index = 0; index < csv.length; index++) {

          if (csv[index].email_empresa == "") {

            bandera = true;
          }

        }

        if (bandera) {
          this.clear = true;
          this.file = null;
          this.fileUrl = null;
          this.$v.$reset();
          this.$store.commit("global/SET_ALERT", {
            msg: "Uno o más registros no cuentan con correo electrónico.",
            show: true,
            type: "error"
          });
        } else {
          this.clear = false;
          await this.uploadFile();
        }

      }*/
    },
    uploadFile: async function() {
      this.loadingFile = true;
      this.alert.status = 'loading';
      try {
        const timestamp = Date.now();
        // const file = `user_files/${this.$route.path.replace('/user/', '')}/${timestamp}_users.csv`;
        let userType = this.$route.path.replace('/user/', '');
        switch(userType) {
          case 'manage':
            userType = 'collaborator'
          break;
          case 'volkswagenSP':
            userType = 'personal_vwsp'
          break;
          case 'utpStudents':
            userType = 'trainee_utp'
          break;
          case 'practitioners':
            userType = 'practicing'
          break;
        }
        const file = `upload_users_files/${userType}/${timestamp}_${userType}.csv`;
        const fileResp = await s3.uploadFile(file, this.file);
        const {Bucket, Key} = fileResp;
        this.alert.status = 'loading';
        await api.uploadUsers(Bucket, Key, userType);
        this.backendError = '';
        this.alert.status = 'success';
        this.loadingFile = false;
        this.file = null;
        this.fileUrl = null;
        this.$v.$reset();
        this.$emit('updateTable');
      } catch (error) {
        if(error.response.data.hasOwnProperty('err')){
          // this.backendError = error.response.data.err.replace(': ', ':<br>').replace(/required.,/g, 'required.<br>');
          this.backendError = error.response.data.err.replace('.', ' ').replace(/required.,/g, 'required.</br>').replace("\n", "<br/>");
          this.$refs['my-info'].show();
          
        }
        this.alert.status = 'error';
        this.loadingFile = false;
        throw error;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#user-file {
  display: flex;
  align-items: center;
  margin: 2rem 0;
}
.upload-btn {
  @extend %audi;
  color: white;
  background-color: black;
  border: 1px solid $black;
  border-radius: 0;
  padding: 5px 10px;
  margin-left: 1rem;
  transition: all 0.3s;
  &.upload-btn--diabled {
    // color: $wg_1;
    color: $black;
    background-color: transparent;
    border: 1px solid $wg_1;
  }
}
.error-msg, .error-msg-back {
  color: $warn_red;
}
.error-msg-back {
  margin-left: 2em;
}
</style>